import React, { useState, useEffect } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";

// const { SearchBar } = Search;

import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";

moment.locale("th");

import { Form, Row, Col } from "react-bootstrap";

// Import Service
// import RegsugarService from "../../services/regsugar.service";
import FarmerMasterService from "../../services/farmermaster.service";
import authService from "../../services/auth.service";
// import approveService from "../../services/approve.service";
import TimeregService from "../../services/timereg.service";

//Import Modal
// import ModalContract from "./ModalContract";
// import ModalMasterapprove from "./ModalMasterapprove";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";
const { ExportCSVButton } = CSVExport;

const ApproveMasterlist = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  // const [showContract, setShowContract] = useState(false);
  // const [farmerselect, farmerSetselect] = useState({});
  // const [showApprove, setShowApprove] = useState(false);
  // const [master_select, setMaster_select] = useState({});

  const [timeregSelect, setTimeregSelect] = useState("");
  const [timeregList, setTimeregList] = useState([]);

  const user = authService.getCurrentUser();

  const getTimeRegList = () => {
    TimeregService.getTimereglist(user.user.user_reg)
      .then((response) => {
        setTimeregList(response.data.data);
      })
      .catch((err) => {
        console.log("fetch timereg List Error :" + err);
      });
  };

  const handleTimeregChange = (e) => {
    setTimeregSelect(e.target.value);
    if (e.target.value != "") {
      getData(user.user.user_reg, e.target.value);
    } else {
      setData([]);
    }
  };

  // const submitEditDetail = (obj) => {
  //   approveService
  //     .approveMasterStatus({
  //       ...obj,
  //       user_id: user.user.user_id,
  //     })
  //     .then((response) => {
  //       if (response.data.success) {
  //         setData((obj) => [
  //           ...obj.map((item) => {
  //             if (item.masterid != response.data.data.masterid) {
  //               return item;
  //             } else {
  //               return response.data.data;
  //             }
  //           }),
  //         ]);
  //         setShowApprove(false);
  //       }
  //     });
  // };
  useEffect(() => {
    getTimeRegList();
  }, []);

  const getData = (user_reg, timereg_id) => {
    setLoading(true);
    if (user.user.member_type === 3) {
      FarmerMasterService.getFarmerMasterForRegistrar(user_reg, timereg_id)
        .then((response) => {
          setData(response.data.data);
        })
        .catch((error) => {
          console.error("error fetching data: ", error);
          setError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (user.user.member_type === 5 || user.user.member_type === 6) {
      FarmerMasterService.getFarmerMasterForRegistrar(0, timereg_id)
        .then((response) => {
          setData(response.data.data);
        })
        .catch((error) => {
          console.error("error fetching data: ", error);
          setError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  // const clickApprove = (row) => {
  //   setMaster_select(row);
  //   setShowApprove(true);
  // };
  // const clickContract = (row) => {
  //   farmerSetselect({
  //     masterid: row.masterid,
  //     person_card_id: row.masteridcard,
  //     approve_status: row.approve_status,
  //   });
  //   setShowContract(true);
  // };
  // const ActionsEdit = (row) => {
  //   return (
  //     <>
  //       <i
  //         className="bi bi-pencil custom-icon-table"
  //         onClick={() => clickApprove(row.row)}
  //       ></i>
  //       <i
  //         className="bi bi-search custom-icon-table"
  //         onClick={() => clickContract(row.row)}
  //       ></i>
  //     </>
  //   );
  // };

  // const actionsEdittFormatter = (cell, row) => {
  //   return <ActionsEdit row={row} />;
  // };

  const columns = [
    {
      text: "masterid",
      dataField: "masterid",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
      csvExport: false,
    },
    {
      text: "บัตรประชาชน",
      dataField: "masteridcard",
      sort: true,
      filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "mastername",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "สร้างโดย",
      dataField: "user_create",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "12%" };
      },
      style: {
        wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "หน. กลุ่ม",
      dataField: "status_text",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "5%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      // style: {
      //   wordBreak: "break-word",
      // },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "อนุมัติ",
      dataField: "approve_status",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "5%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "อนุมัติโดย",
      dataField: "approve_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "รหัสเกษตร",
      dataField: "farmer_card",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "วันที่เริ่ม",
      dataField: "start_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      formatter: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "5%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "วันที่สิ้นสุด",
      dataField: "end_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      formatter: (cell, row) => {
        console.log(row);
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell, row) => {
        console.log(row);
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "5%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },

    // {
    //   text: "ข้อความ",
    //   dataField: "comments",
    //   sort: true,
    //   editable: false,
    //   filter: textFilter({ placeholder: "ค้นหา" }),
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "10%" };
    //   },
    //   style: {
    //     wordBreak: "break-word",
    //     textAlign: "center",
    //   },
    // },
    // {
    //   text: "แก้ไข",
    //   dataField: "edit",
    //   isDummyField: true,
    //   editable: false,
    //   formatter: actionsEdittFormatter,
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "13%" };
    //   },
    //   style: {
    //     wordBreak: "break-word",
    //     textAlign: "center",
    //   },
    // },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "<<",
    lastPageText: ">>",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  if (error) return `Error :${error}`;

  return (
    <div>
      {loading ? <LoadingAlert /> : ""}
      {/* <ModalMasterapprove
        show={showApprove}
        hidden={setShowApprove}
        master_select={master_select}
        afterSubmit={submitEditDetail}
      />
      <ModalContract
        show={showContract}
        hidden={setShowContract}
        farmerselect={farmerselect}
      /> */}
      <ToolkitProvider
        bootstrap4
        keyField="masterid"
        data={data}
        columns={columns}
        exportCSV={{
          fileName: "ข้อมูลการอนุมัติ.csv", // "ข้อมูลสมาชิก_" + {cell} + ".csv",
          separator: ",",
          ignoreHeader: false,
          noAutoBOM: false,
          blobType: "text/plain;charset=utf-8",
          onlyExportFiltered: true,
          exportAll: false,
        }}
        search
      >
        {(prop) => (
          <React.Fragment>
            <Row>
              <Col md={8}>
                <ExportCSVButton
                  {...prop.csvProps}
                  style={{
                    padding: ".375rem .75rem",
                    fontSize: "1rem",
                    // float: "right",
                  }}
                >
                  <i className="bi bi-download"></i>
                </ExportCSVButton>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Select
                    name="approve_status"
                    value={timeregSelect}
                    onChange={handleTimeregChange}
                  >
                    <option value="">เลือกรอบที่จดทะเบียน</option>
                    <option value="0">ทั้งหมด</option>
                    {timeregList.map((a) => (
                      <option key={a.timereg_id} value={a.timereg_id}>
                        {a.timereg_desc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <hr />
            <BootstrapTable
              // bootstrap4
              // keyField="farmer_id"
              // columns={columns}
              // data={data}
              pagination={pagination}
              //   cellEdit={cellEditFactory({
              //     mode: "click",
              //     blurToSave: true,
              //     afterSaveCell,
              //   })}
              filter={filterFactory()}
              // loading={true}
              {...prop.baseProps}
              // cellEdit={cellEditFactory({
              //   mode: "click",
              //   blurToSave: true,
              //   afterSaveCell: handleChange,
              //   beforeSaveCell: beforeSaveCell,
              // })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default ApproveMasterlist;
